// extracted by mini-css-extract-plugin
module.exports = {"componentsSmsCode":"styles_componentsSmsCode__15r2P","sendBtn":"styles_sendBtn__3_oDb"};